// removed by extract-text-webpack-plugin
module.exports = {"title":"header__title-3Cwkd"};


//////////////////
// WEBPACK FOOTER
// ./components/common/custom-order/cities/header/header.css
// module id = 813
// module chunks = 0